/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

export * from "./models/index.js";
export { StorageClient } from "./storageClient.js";
export * from "./operationsInterfaces/index.js";
